import React from 'react';
import EventEditModal from "../EventEditModal";
import {useEventSegments} from "./useEventSegment";
import IsLoading from "../../../shared/components/IsLoading";
import ErrorPage from "../../../shared/components/ErrorPage";

// 세그먼트 이벤트(event_segment_master) 편집. 이벤트 편집 화면에 세그먼트 조건 선택만 더한다.
const SegmentEventEditModal = (props) => {
    const {data: segmentList, isLoading, error} = useEventSegments();

    if (isLoading) return <IsLoading/>;
    if (error) return <ErrorPage error={error}/>;

    return <EventEditModal {...props} segmentList={segmentList || []}/>;
}

export default SegmentEventEditModal;
